import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { OnboardingStore } from './onboarding.store';
import { Session } from '../../services/Session';
import { MeetingStepComponent } from './steps/meeting-step.component';
import { InviteStepComponent } from './steps/invite-step.component';
import { SuccessScreenComponent } from './steps/success-screen.component';
import { SignupBannerComponent } from '../signup-banner/signup-banner.component';
import { PendingLogoService } from '../../tpiq-services/pending-logo.service';
import { SignupService } from '../../tpiq-services/signup.service';
import { ToastService } from '../../services/Toast.service';
import { TOAST_TYPE } from '../../constants/Tpiq.constants';

@Component({
  selector: 'app-onboard-dashboard',
  standalone: true,
  imports: [
    CommonModule,
    MeetingStepComponent,
    InviteStepComponent,
    SuccessScreenComponent,
    SignupBannerComponent,
  ],
  templateUrl: './onboard-dashboard.component.html',
  styleUrl: './onboard-dashboard.component.scss',
})
export class OnboardDashboardComponent implements OnInit {
  store: OnboardingStore;
  userName = '';
  smallLogo = 'https://static.taxplaniq.com/futurefirm/favicon_new.png';

  constructor(
    store: OnboardingStore,
    private pendingLogoService: PendingLogoService,
    private signupService: SignupService,
    private toastService: ToastService,
  ) {
    this.store = store;
  }

  ngOnInit() {
    const user = Session.getUser();
    this.userName = user?.first_name || '';
    this.store.reset(); // sets STEP_LABELS + maxInvites based on plan

    // Resume from where user left off
    const status = user?.onboardingStatus;
    if (status === 'Schedule') this.store.jumpTo('Book your Meeting');
    if (status === 'Invite')   this.store.jumpTo('Invite Additional User');

    this.uploadPendingLogo();
  }

  private uploadPendingLogo() {
    if (!this.pendingLogoService.has()) { return; }
    const file = this.pendingLogoService.get();
    const org = Session.getOrg();
    const userId = Session.getUser()?.id;
    if (!org || !userId) { return; }
    this.signupService.uploadLogo(org, userId, file).subscribe({
      next: () => { this.pendingLogoService.clear(); },
      error: () => {
        this.pendingLogoService.clear(); // prevent retry loops
        this.toastService.pop(TOAST_TYPE.info, 'Logo upload failed. You can re-upload it in Settings.');
      }
    });
  }
}
